<template>
    <div style="display: flex;flex-direction: column;justify-content: space-between;min-height: 100vh;">
        <div class="container1">
            <h1>信息科技（浙江教育版）配套数字资源</h1>
            <div class="list">
                <div class="item" v-for="item in bookDTOList" :key="item.bookId" @click="openBook(item.bookId)">
                    <img :src="item.bookCoverUrl" alt="">
                    <div class="text">{{ item.bookName }}</div>
                </div>
            </div>
        </div>
        <FooterBottom />
    </div>
</template>

<script>
import { loginTech, getKxResource } from '@/api/science'
import { getBookInfo } from '@/api/videoResource'
import Cookies from 'js-cookie'
import store from '@/store'
import { getUser } from '@/api/user'
import FooterBottom from '@/components/FooterBottom.vue'
export default {
    name: 'KxResource',
    components: {
        FooterBottom
    },
    data() {
        return {

            bookDTOList: []
        }
    },
    created() {
        if (this.$route.query.code) {
            this.loginTech()

            this.$router.replace({
                path: this.$route.path,
                query: {}
            })
        }else{
            this.getKxResource()
        }
    },
    methods: {
        loginTech() {
            loginTech({
                code: this.$route.query.code
            }).then(res => {
                Cookies.set('token', res.data.token)
                store.commit('setUser', res.data) // 先设置userId
                getUser(res.data.userId).then(zsUser => {
                    store.commit('setUser', zsUser.data)
                    this.getKxResource()
                })
            })
        },
        getKxResource() {
            getKxResource({
                page: 1,
                size: 10,

            }).then(res => {
                this.bookDTOList = res.data.bookDTOList
            })
        },
        async openBook(bookId) {
            const res = await getBookInfo({
                bookId
            })
            window.open(res.data[0]?.url, '_blank')
        }
    }
}
</script>
<style lang="less" scoped>
.container1 {
    padding-top: 1px;
    width: 1200px;
    margin: 8px auto;
    background: #fff;
    overflow: visible !important;

    h1 {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.8);
        text-align: center;
        line-height: 97px;
        width: 1103px;
        margin: 0 auto;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        column-gap: 65px;
        row-gap: 57px;
        padding: 40px;

        .item {
            cursor: pointer;

            img {
                width: 232px;
                height: 232px;
                display: block;
                margin-bottom: 16px;
            }

            .text {
                font-size: 16px;
                color: rgba(0, 0, 0, 0.8);
                text-align: center;
                line-height: 24px;
            }
        }
    }
}
</style>